import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  Goals = 'Goals',
  MonteCarlo = 'MonteCarlo',
  Longevity = 'Longevity',
  MarketScenarios = 'MarketScenarios',
}

export const queryKeys = {
  monteCarlo: (clientId: string, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.MonteCarlo,
    clientId,
    fpId,
  ],
  longevity: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.Longevity,
    clientId,
    fpId,
  ],
  marketScenarios: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.MonteCarlo,
    QueryKey.MarketScenarios,
    clientId,
    fpId,
  ],
};
